import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { faQrcode } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-qr-code-input',
  template: `
    <div class="d-flex align-items-center position-relative">
      <app-input type="text" class="w-100" [name]="name" [control]="control" autocomplete="nope"
                 [placeholder]="placeholder" [inputStyles]="control.value ? 'padding-right: 36px' : ''"></app-input>
      <a *ngIf="control.value" class="qr-code-btn"
         [ngbTooltip]="'action.viewQR' | transloco" #t="ngbTooltip" (mouseenter)="t.open()" (mouseleave)="t.close()"
         [ngbPopover]="qrCodePreview" triggers="click" [autoClose]="'outside'">
        <fa-icon [icon]="viewQRCodeIcon" [size]="'lg'"></fa-icon>
      </a>
    </div>
    <ng-template #qrCodePreview>
      <qrcode [qrdata]="getQrCodeData()" [width]="175" errorCorrectionLevel="M" elementType="img"></qrcode>
    </ng-template>
  `,
  styleUrls: ['./qr-code-input.component.scss']
})
export class QrCodeInputComponent {
  @Input() qrCodePrefix: string;
  @Input() control: UntypedFormControl;
  @Input() name: string;
  @Input() placeholder: string;

  protected readonly viewQRCodeIcon = faQrcode;

  getQrCodeData(): string {
    if (!this.qrCodePrefix) {
      return this.control.value;
    }
    return `${this.qrCodePrefix}|${this.control.value}`;
  }
}
